/**
 * Russian language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_RU_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Мой профиль',
    'lvt.menu.tw_profile': 'Профиль TW',
    'lvt.menu.company_profile': 'Профиль компании',
    'lvt.menu.my_notifications': 'Мои уведомления',
    'lvt.menu.sign_out': 'Выход',

    // footer
    'lvt.footer.back_to_top': 'Наверх',
    'lvt.footer.terms_of_use': 'Условия использования',
    'lvt.footer.privacy_policy': 'Политика конфиденциальности',
    'lvt.footer.support_information': 'Справочная информация',
    'lvt.footer.transwide_home': 'Главная страница Transwide',
    'lvt.footer.license_nr': 'Номер лицензии:',
    'lvt.footer.build_version': 'Версия сборки:',

    // order list columns
    'lvt.order_list.header': 'Список заказов',
    'lvt.order_list.column.shipperCompany': 'Грузоотправитель',
    'lvt.order_list.column.reference': 'Номер',
    'lvt.order_list.column.status': 'Статус',
    'lvt.order_list.column.statusReason': 'Причина статуса',
    'lvt.order_list.column.senderCompany': 'Компания-отправитель',
    'lvt.order_list.column.senderZipcode': 'Почтовый индекс отправителя',
    'lvt.order_list.column.senderCity': 'Город отправителя',
    'lvt.order_list.column.receiverCompany': 'Компания-получатель',
    'lvt.order_list.column.receiverZipcode': 'Почтовый индекс получателя',
    'lvt.order_list.column.receiverCity': 'Город получателя',
    'lvt.order_list.column.carrierName': 'Компания-перевозчик',
    'lvt.order_list.column.plannedPickupEndDate': 'Запланированная отгрузка',
    'lvt.order_list.column.etaPickup': 'РВП в пункт отгрузки',
    'lvt.order_list.column.delayAtPickup': 'Задержка в пункте отгрузки',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Запланированная доставка',
    'lvt.order_list.column.etaDelivery': 'РВП в пункт доставки',
    'lvt.order_list.column.delayAtDelivery': 'Задержка в пункте доставки',
    'lvt.order_list.column.timestamps': 'Отметки времени',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Запрошено',
    'lvt.order_list.status.failed': 'Ошибка',
    'lvt.order_list.status.waiting': 'Ожидание',
    'lvt.order_list.status.active': 'Выполняется',
    'lvt.order_list.status.stopped': 'Ошибка',
    'lvt.order_list.status.completed': 'Завершено',
    'lvt.order_list.status.cancelled': 'Отменено',
    'lvt.order_list.status.timeout': 'Остановлено',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Перевозчик не назначен',
    'lvt.order_list.status_reason.plate_number_not_present': 'Номерной знак отсутствует',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Номерной знак не идентифицирован',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Номерной знак не действителен',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Техническая ошибка при создании тура в GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'строк на странице',
    'lvt.order_list.pagination.first': 'Первый',
    'lvt.order_list.pagination.previous': 'Предыдущий',
    'lvt.order_list.pagination.next': 'Следующий',
    'lvt.order_list.pagination.last': 'Последний',
    'lvt.order_list.pagination.no_orders_found': 'Заказы не найдены',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Прицеп',
    'lvt.map.tracked_device.tractor': 'Тягач',
    'lvt.map.tracked_device.mobile': 'Мобильный телефон',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Открыть список заказов',
    'lvt.map.traffic_information.traffic': 'Траффик',
    'lvt.map.traffic_information.fast': 'Быстрый',
    'lvt.map.traffic_information.slow': 'Медленный',
    'lvt.map.pickup_popup.pickup': 'Отгрузка',
    'lvt.map.pickup_popup.date': 'Дата',
    'lvt.map.pickup_popup.address': 'Адрес',
    'lvt.map.delivery_popup.delivery': 'Доставка',
    'lvt.map.delivery_popup.date': 'Дата',
    'lvt.map.delivery_popup.address': 'Адрес',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'На пути к пункту доставки',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'На пути к пункту отгрузки',
    'lvt.map.current_gps_popup.current_speed': 'Текущая скорость',
    'lvt.map.current_gps_popup.average_speed': 'Средняя скорость',
    'lvt.map.current_gps_popup.last_location_update': 'Последнее обновление адреса',
    'lvt.map.current_gps_popup.eta': 'РВП',
    'lvt.map.current_gps_popup.planned_time': 'Запланированное время',
    'lvt.map.current_gps_popup.arrival_delay': 'Задержка прибытия',
    'lvt.map.current_gps_popup.speed_unit': 'км/ч',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Прибыл в отправной пункт',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Не прибыл в отправной пункт',
    'lvt.order_list.timestamp.left_origin': 'Покинул отправной пункт',
    'lvt.order_list.timestamp.not_left_origin': 'Не покинул отправной пункт',
    'lvt.order_list.timestamp.arrived_at_destination': 'Прибыл в пункт назначения',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Не прибыл в пункт назначения',
    'lvt.order_list.timestamp.left_destination': 'Покинул пункт назначения',
    'lvt.order_list.timestamp.not_left_destination': 'Не покинул пункт назначения',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-ru.ts